interface PageParams {
    pathname: string;
    generalKeys: string[];
    tabs: string[];
    theme?: string;
    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'delta-pro-ultra-x',
    generalKeys: ['product_ps_delta_dprs'],
    // generalKeys: ['product_home_yj751'],
    tabs: ['product', 'Spec', 'support'],
    theme: 'black',
    sites: ['us', 'ca'],
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
